import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const GoogleRSA = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14933)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip1_1503_14933)">
            <path
              d="M170.6 42.1391L179.924 26.347C181.108 27.0369 187.08 30.3068 188.045 30.9287L178.721 46.7216C177.702 48.0544 169.309 44.1617 170.6 42.1383V42.1391Z"
              fill="#FBBC04"
            />
            <path
              d="M197.39 42.137L188.067 26.3459C186.763 24.1998 183.956 23.4198 181.65 24.6874C179.345 25.955 178.643 28.6854 179.946 30.9274L189.269 46.7205C190.573 48.8656 193.38 49.6454 195.686 48.378C197.891 47.1103 198.694 44.283 197.39 42.1389V42.137Z"
              fill="#3D7FFE"
            />
            <path
              d="M174.639 48.988C177.223 48.988 179.319 46.9663 179.319 44.4726C179.319 41.9788 177.223 39.9572 174.639 39.9572C172.054 39.9572 169.958 41.9788 169.958 44.4726C169.958 46.9663 172.054 48.988 174.639 48.988Z"
              fill="#34A853"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1503_14933">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14933">
            <rect
              width="28"
              height="28"
              fill="white"
              transform="translate(170 23)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
GoogleRSA.displayName = 'GoogleRSA';
